import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "AddCustomProduct" }
const _hoisted_2 = { class: "CampaignEditorRow" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "AddCustomProductBlockLabel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoadingWrapper, {
      classes: [
			'CampaignEditorRow',
			'CampaignEditorSubtitle'
		],
      isLoading: _ctx.isLoading,
      tag: "h1"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" Custom products ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createVNode(_component_LoadingWrapper, {
      classes: [
				'CampaignEditorRow',
				'CampaignEditorText'
			],
      isLoading: _ctx.isLoading,
      tag: "p"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode(" This section allows you to customise your campaign by adding extra products such as emails and remarketing. ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createVNode(_component_LoadingWrapper, {
      classes: [
				'CampaignEditorRow',
				'CampaignEditorSubtitle'
			],
      isLoading: _ctx.isLoading,
      tag: "h2"
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createTextVNode(" Add custom product ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customProductButtons, (product) => {
        return (_openBlock(), _createBlock(_component_LoadingWrapper, {
          classes: ['AddCustomProductBlockWrapper'],
          isLoading: _ctx.isLoading,
          key: product.type
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.selectCustomProductType(product.type)),
              class: "AddCustomProductBlock"
            }, [
              _createElementVNode("i", {
                class: _normalizeClass([
					'AddCustomProductBlockIcon',
					product.icon
				])
              }, null, 2 /* CLASS */),
              _createElementVNode("span", _hoisted_4, _toDisplayString(product.label), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_3)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["isLoading"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}